<template>
  <!-- <div class="data_brain_wrap">
    <div class="brain_title">智达康</div>
    <div class="brain_desc">数智赋能、高效协同，助力实现产业高质量发展</div>

    <el-row class="card_wrap" type="flex">
      <el-col
        class="brain_item"
        :lg="7"
        :sm="11"
        :xs="11"
        v-for="(item, index) in cardList"
        :key="index"
      >
        <div class="item_title">{{ item.title }}</div>
        <div class="item_desc">{{ item.desc }}</div>
        <div class="item_navigate" @click="handleNavigate">了解详情 >></div>
        <div class="item_bg"></div>
      </el-col>
    </el-row>
  </div> -->

  <div class="company_info">
    <!-- <div class="company_img">
      <img src="@/assets/img/cover.jpg" style="width: 100%; height: 100%;" alt="">
    </div> -->
    <div class="company-text">
      <div class="title">走进智达康</div>
      <div class="sub-title">ABOUT US</div>
      <div class="company-text-desc">
        <span>
          四川省智达康科技有限公司在党建引领下，致力于成为一家立足社区，以“益家庭、益社会、益国家”为宗旨，集“智能、普惠、专业”于一体的康养服务公司。公司先后获得了国家养老服务AAAAA认证、质量管理体系认证、环境管理体系认证、职业健康安全管理体系认证等。是2024年度国家级养老服务标准化试点项目承担单位、四川省爱心企业、四川省“质量强省建设单位领军企业培育对象”、成都市百佳社区商业企业、西南石油大学劳动教育实践基地、成都医学院护理学院科研合作单位、四川省养老服务发展协会会员单位、成都市医养结合协会长护专委会副会长单位、成都市养老协会理事单位、新都区爱国拥军理事单位、新都区红十字会博爱工作站。近年来，公司先后获得各级表彰荣誉60余项。
        </span>
        <span>
          公司创建了“三工三联，五位一体”的服务模式和一套相对完善、规范、科学、有效的“531”质量管理体系；并邀请省内多位中医药专家成立顾问组，积极应用中医药优势创新开展医养结合探索。
        </span>
        <span>
          经过10余年的努力和发展，公司现拥有员工近500人，涵盖医疗、护理、社会工作、康复治疗、心理咨询、健康管理等专业人才和养老护理员、病患陪护员、老年人能力评估师等职业技能人才。公司下设9个分公司，已初步建立起相对完整的业务运营产业链。业务包括居家养老、社区养老（含社区嵌入式养老）、机构养老、长护险服务、康复辅助器具租售、康养智慧智能管理服务平台开发运营、适老化设计与改造、养老服务人才培养、智慧养老服务产品研发应用等领域，服务区域辐射成都、德阳、达州、宜宾、泸州、遂宁6市10余个县(市、区)
        </span>
      </div>
    </div>
    <div class="bottom_circle">
      <div class="left_post">
        <div class="post">
          <img src="../../assets/icon_diamond.png" >
          <span>参与制定国家长护险制度制作等等等</span>
        </div>
        <div class="post">
          <img src="../../assets/icon_diamond.png" >
          <span>参与制定国家长护险制度制作等等等</span>
        </div>
        <div class="post">
          <img src="../../assets/icon_diamond.png" >
          <span>参与制定国家长护险制度制作等等等</span>
        </div>                
      </div>
      <div class="right_img">
        <img src="../../assets/sg.png" style="width: 40%; height: 80%; right: 2%" >
      </div>
    </div>    
  </div>

</template>

<script>
export default {
  data() {
    return {
      cardList: [
        {
          title: '数据中心',
          desc: '通过智达康服务系统完成服务过程数字化',
        },
        {
          title: '居家养老',
          desc: '让长者不离家，由专业服务人员上门提供日常照料、康复护理等定制化服务。',
        },
        {
          title: '社区养老',
          desc: '以社区为平台，为长者提供日间照料、餐饮和文娱活动等便捷的支援服务。',
        },
        {
          title: '机构养老',
          desc: '入住我们的机构，享受全天候的住宿、医疗护理和一体化生活保障服务',
        },
        {
          title: '嵌入式社区养老',
          desc: '在社区内嵌入小型养老机构，兼具日托与上门服务，实现家门口的专业照护',
        },
        {
          title: '长护险',
          desc: '专业提供长护险上门服务，为失能长者提供合规、专业的居家照护',
        },
      ],
    }
  },
  methods:{
    handleNavigate(){
      this.$router.push('/production/1').catch((v) => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.data_brain_wrap {
  padding: 50px 0;
  background: #e8eef2;
  text-align: center;
  .brain_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40PX;
    }
  }
  .card_wrap {
    width: 70%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-around;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
    .brain_item {
      transition: background-color 1s;
      padding: 30px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40PX;
        border-radius: 10PX;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20PX;
        &:nth-child(-n+2){
          margin-top: 0;
        }
      }
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 40px;
      position: relative;
      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          134deg,
          #0649b8 1%,
          #0a7fd7 41%,
          #03d2c5 99%
        );
        opacity: 0;
        transition: all 0.5s;
        border-radius: 20px;
        z-index: 1;
      }
      &:hover .item_bg{
        opacity: 1;
      }
      &:hover .item_title {
        color: #fff;
      }
      &:hover .item_desc {
        color: #fff;
      }
      .item_title {
        transition: all 0.5s;
        font-size: 30px;
        font-weight: bold;
        color: #203040;
        text-align: left;
        padding: 20px 0 40px 0;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }
      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 18px;
        min-height: 110px;
        @media screen and (max-width: 768px) {
          min-height: 110PX;
          text-indent: 2em;
          font-size: 12px;
        }
      }
      .item_navigate {
        width: 100PX;
        height: 30PX;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          margin-bottom: 10PX;
          font-size: 14px;
        }
      }
    }
  }
}

.company_info {
    display: flex;
    padding: 2vw;
    width: 100%;
    text-align: center;
    background-color: #f4f8fe;
    padding-top: 6.7rem;
    flex-direction: column;

    .company_img {
      max-width: 1400px;
      height: 80%;
      margin-left: auto;
      margin-right: auto;
      overflow: hidden;
    }

    .company-text {
      height: 100%;

      .title {
        text-align: center;
        font-size: 4.8rem;
        font-weight: bold;
        color: #000;
      }

      .sub-title {
        font-size: 2.4rem;
        margin-top: 0.1rem;
        height: 5rem;
        color: #d7d7d7;
        text-align: center;
      }

      .company-text-desc {
        margin: 4.7rem 4rem;
        font-size: 2.7rem;
        color: #666666;
        line-height: 4.8rem;
        text-align: left;
      }
    }
}

.bottom_circle {
  width: 100%;
  display: flex;
  background-color: #f4f8fe;
  margin: 2rem 4rem;
  height: 41.7rem;

  h1 {
    font-size: 40px;
    padding-bottom: 20px;
    @media screen and (max-width: 768px) {
      font-size: 1.15rem;
      width: 60%;
      margin: 0 auto;
    }
  }

  .left_post {
    display: flex;
    flex-direction: column;

    .post {
      display: flex;
      border-top: 4px #d9d9d9 solid;
      padding: 3.2rem 0;
      text-align: left;

      &:last-child {
        border-bottom: 4px solid #d9d9d9;
      }

      img {
        width: 2rem;
        height: 2rem;
        margin-top: .8rem;
        margin-right: 1.2rem;
      }

      span {
        font-size: 3.2rem;
        line-height: 3.5rem;
        width: 36rem;
        color: #000;
      }
    }
  }

  .right_img {
    width: 74%;
  }
}
</style>